export const EREVIS_LIVE_STAGING_HOST = 'erevis-live-staging.bigworldcapitalgroup.com'
export const EREVIS_OMS_STAGING_HOST = 'erevis-oms-staging.bigworldcapitalgroup.com'

function currentHostname() {
  if (typeof window === 'undefined') return ''
  return window.location?.hostname || ''
}

function clientEnvLabel() {
  return import.meta.env.VITE_EREVIS_ENVIRONMENT_LABEL || ''
}

export function getRuntimeEnvironment(hostname = currentHostname(), environmentLabel = clientEnvLabel()) {
  const normalizedHost = String(hostname || '').toLowerCase()
  const isLiveStaging = normalizedHost === EREVIS_LIVE_STAGING_HOST
  const isOmsStaging = normalizedHost === EREVIS_OMS_STAGING_HOST
  const customLabel = String(environmentLabel || '').trim()
  const headerLabel = isOmsStaging
    ? 'OMS Staging'
    : isLiveStaging
      ? 'Live Staging'
      : customLabel || null

  return {
    isLiveStaging,
    isOmsStaging,
    isNonProduction: Boolean(headerLabel),
    browserTitle: isLiveStaging ? 'Erevis Staging' : (headerLabel ? `Erevis ${headerLabel}` : 'Erevis'),
    headerLabel,
  }
}
